module.exports = __webpack_public_path__ + "img/ftm-orange.aed2fa10.png";